import React from 'react'
export default function FooterCopyright() {
  return(
    <>&copy; 2021 SA Harvest - All rights reserved</>
  )
}
